var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current inline-block",class:_vm.size?`w-${_vm.size} h-${_vm.size}`:`w-6 h-6`,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","fill":"currentColor"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }